import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import {
  GetEndpointsQuery,
  GetEndpointsResponse,
} from '@hud/portal-dtos/webapp-endpoint.dto';
import { faro } from '@grafana/faro-react';
import { PORTAL_BASE } from '../consts';

export const ENDPOINTS_ID = 'endpoints';

export default function useEndpoints(
  params: GetEndpointsQuery,
  enabled = true,
) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [ENDPOINTS_ID, params],
    queryFn: async () => {
      const startTime = new Date();
      const response = await client.get<GetEndpointsResponse>(
        `${PORTAL_BASE}/endpoints`,
        {
          params,
        },
      );
      faro.api.pushMeasurement({
        type: 'getEndpoints',
        values: {
          time: new Date().getTime() - startTime.getTime(),
        },
      });
      return GetEndpointsResponse.parse(response.data);
    },
    enabled: isReady && enabled,
  });
}
